import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import Input from '../../../../Core/Fields/Floating/Input';
import { useState } from 'react';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';

const Tab1 = ({ date, no, grn, vendor, potime, sourceWarehouse, activityboll ,poOrder }) => {
   const [showActivity, setShowActivity] = useState(true);
   const [hours, minutes] = potime.split(':');
   const result = `${hours}:${minutes}`;
   return (
      <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px", height: '71vh', overflowY: 'scroll',flexWrap:'nowrap' }} >
         <div className="col-12 mt-1 mb-2">
            <div className="row">
               <div className="col-md-6">
                  <Input id="orderNo" label="No." readOnly value={no} style={{ height: '30px' }} />
               </div>
               <div className="col-md-6">
                  <Input id="orderdatepo" readOnly style={{ height: '30px' }} label="Date" value={date} />
               </div>
            </div>
         </div>
         <div className="col-12 mt-1 mb-2">
            <div className="row">
               <div className="col-6">
                  <Input id="po" label="PO No." readOnly value={poOrder} style={{ height: '30px' }} />
               </div>
               <div className="col-6">
                  <Input id="grnno" label="GRN No." readOnly value={grn} style={{ height: '30px' }} />
               </div>
            </div>
         </div>
         <div className="col-12 mb-2" >
            <Input id="vandortitle" label="Supplier" readOnly value={vendor} style={{ height: '30px' }} />
         </div>
         <div className="col-12 mb-2" >
            <Input id="vandortitle" label="Source Bin" readOnly value={sourceWarehouse} style={{ height: '30px' }} />
         </div>
         <div className="col-12 mb-2" >
            <Input id="pdate"   label="Post Date" readOnly  value={date} style={{ height: '30px' }} />
          
         </div>
         <div className="col-12 mb-2">
            <Input id="vandortitle" label="Post Time" readOnly value={result} style={{ height: '30px' }} />
         </div>
         <CollapsibleSection title="Taxes and Charges"></CollapsibleSection>
         <div className='col-12'>
            <div>
               <div className="col-12">
                  <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                     <p className="firstcolor m-0" >
                        Activity
                     </p>
                     <GetIcon
                        iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                        size={22}
                     />
                  </div>
                  {showActivity && (
                     <VersionHistory doctype="Stock Entry" docname={no} activityboll={activityboll} />

                  )}
               </div>
            </div>
         </div>
      </div>
   )
}

export default Tab1